module.exports = __webpack_public_path__ + "img/logo_on_sphere.c21b8a4e.svg";